module.exports = __webpack_public_path__ + "static/akwarium-1-d147926100da2b938f9f7b5428c12775.jpg";